// check if Bing maps are available, the Microsoft.Maps object should exist after page load
window.addEventListener('load', function(event) {
  let mapElement = this.document.querySelector('#map');
  const searchBarComponents = document.querySelectorAll('.search-bar');
  if (mapElement || searchBarComponents.length) {
    let bingAvailable = true;
    if ( typeof Microsoft === 'undefined') {
      bingAvailable = false;
    } else {
      if ( typeof Microsoft.Maps === 'undefined') {
        bingAvailable = false;
      }
    }
    // Handle Bing Unavailable
    if ( !bingAvailable) {
      handleNoBing();
    }
  }
});

// Set the display status of elements on Search Results page depending on results found
const setSearchResultsPageLayout = function( devData ) {
  let noResultsWrap = document.querySelector('.search-no-results');
  let mapElement = document.querySelector('#map');
  let searchResList = document.querySelector('.search-results--list');
  let searchResWrap = document.querySelector('.search-results--wrap');

  if (devData.data.items.length === 0) {
    noResultsWrap.style.display = 'block';
    noResultsWrap.style.visibility = 'visible';
    noResultsWrap.style.position = 'relative';
    mapElement.style.display = 'none';
    searchResList.style.display = 'none';
    searchResWrap.classList.add('no-results');
    searchResWrap.removeAttribute('style');
    windowUtils.removeOrientationListener(resizeMapContainer);
  } else {
    noResultsWrap.style.display = 'none';
    noResultsWrap.style.visibility = 'hidden';
    noResultsWrap.style.position = 'relative';
    mapElement.style.display = 'block';
    searchResList.style.display = 'block';
    // set up event handlers to make sure map sizes correctly
    resizeMapContainer();
    windowUtils.addOrientationListener(resizeMapContainer);
  }
};

function updateSearchResultsInfo(message, showInfo) {
  const SEARCH_BAR_INFO = document.querySelector('.search-bar--info');
  SEARCH_BAR_INFO.innerHTML = message;
  if (showInfo) {
    SEARCH_BAR_INFO.classList.add('show');
  }
}

// initBingMap is passed as a callback to loading Microsoft Maps (defined in Sitecore)
function initBingMap() {
    const searchBarComponents = document.querySelectorAll('.search-bar');
    if (searchBarComponents) {
        Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
            callback: onLoad,
        });
        function onLoad() {
            suggestedDevelopments.init();
            searchBarComponents.forEach((component) => {
                const location = component.querySelector('.autocomplete--field');
                // add Safari-only autocorrect attribute if using Safari browser
                if (detectSafari) {
                    location.setAttribute('autocorrect', 'off');
                }
                // add autocapitalize attribute
                if ('visualViewport' in window) {
                    location.setAttribute('autocapitalize', 'off');
                }
                // Initialize the autosuggest functionality
                const autosuggest = new SearchAutosuggest(location);
            });
        }
    }

    const DIRECTIONS_LINK_WRAPPER = document.querySelector('.maps-directions');
    if (DIRECTIONS_LINK_WRAPPER) {
        const DIRECTIONS_LINK = document.getElementById('getDirectionLink').href;
        const REGEX = new RegExp('cp=(.*)~(.*)&lvl');
        const LON_LAT_MATCH = DIRECTIONS_LINK.match(REGEX);
        const LATITUDE = parseFloat(LON_LAT_MATCH[1]);
        const LONGITUDE = parseFloat(LON_LAT_MATCH[2]);
        const MAP = new Microsoft.Maps.Map('.maps-directions #map', {
            center: new Microsoft.Maps.Location(LATITUDE, LONGITUDE),
            disableScrollWheelZoom: true,
            zoom: 15,
            showMapTypeSelector: false,
        });

        const MAP_CENTER = MAP.getCenter();

        //Create custom Pushpin
        const PIN = new Microsoft.Maps.Pushpin(MAP_CENTER, {});

        MAP.entities.push(PIN);
    }

    const SEARCH_RESULTS_FILTERS = document.querySelector('.search-bar--filters .search-bar');
    if (SEARCH_RESULTS_FILTERS) {
        const searchResultsContainer = document.querySelector('.search-results');
        searchResultsComponent.init(searchResultsContainer, true);
    }


    const localAreaComponent = document.querySelector('.local-area-component');

    if (localAreaComponent) {
        const options = {
          root: null,
          rootMargin: '0px',
          threshold: 0.2,
        };

        // set up intersection observer on Local Area Component
        let observer = new IntersectionObserver(handleLocalAreaIntersect, options);
        observer.observe(localAreaComponent);
    }
}
function getSearchListDevelopmentHTML(devId, itemsInfo, numberOfProperties, NO_OF_PROPS, NO_OF_PROP ) {
  let phoneNumberCollapsed = itemsInfo.callTracking.phoneNumber.replace(/\s/g, '');
  return `<a id="#${devId}"></a>
    <div class="item-wrapper">
      <div class="result-wrapper loaded">
        <div class="image-wrapper">
          <a href="javascript:void(0);" data-dev="${devId}" class="big-link"></a>
          <img width="558" height="280" loading="lazy" src="${itemsInfo.previewImage.path}" alt="${itemsInfo.previewImage.alt}">
        </div>
        <div class="content-wrapper">
          <div class="content-info">
            <a href="javascript:void(0);" data-dev="${devId}" class="big-link"></a>
            <div class="info-wrapper">
              <h2>${itemsInfo.name}</h2>
              <span class="address">${itemsInfo.address}</span>
            </div>
          </div>
          <div class="bottom-wrapper">
            <div class="bottom-info">
              ${
                itemsInfo.homeIcon ?
                  `<div class="details-content">
                    <div class="icon"><img src="${itemsInfo.homeIcon.path}" alt="${itemsInfo.homeIcon.alt}"> ${itemsInfo.propertyTypes}</div>
                    <div class="icon"><img src="${itemsInfo.currencyIcon.path}" alt="${itemsInfo.currencyIcon.alt}"> ${itemsInfo.priceRange}</div>
                  </div>` :
                  ``
              }
              <div class="action-wrapper">
              ${
                itemsInfo.callTracking ?
                  `<div class="call-tracking-number">
                  <a href="tel:${phoneNumberCollapsed}">${itemsInfo.callTracking.phoneNumber}</a>
                </div>` :
                  ``
              }
              </div>
            </div>
            <p class="description">${itemsInfo.shortDescription}</p>
            <div class="cta-wrapper">
            ${
              numberOfProperties > 0 ?
                `<button type="button" class="prop-table button button--secondary" aria-expanded="false" aria-controls="prop-table-${devId}">${
                    numberOfProperties > 1 ? `${NO_OF_PROPS}` : `${NO_OF_PROP}`
                  }<span class="icon-plus"></span></button>` :
                ``
            }

              <a href="${itemsInfo.viewDevelopmentButton.url}" class="button button--primary" title="${
        itemsInfo.viewDevelopmentButton.name
      }">${itemsInfo.viewDevelopmentButton.name}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="table-results-wrapper" id="prop-table-${devId}">
        <div class="property-list-component alt-background">
          <input type="hidden" class="num-per-page" value="2">
          <input type="hidden" class="data-source-page-id" value="">
          <div class="table-wrapper">
          </div>
        </div>
      </div>
    </div>
  `;
}
async function getSearchTableData(developmentDiv, isFirst, initialSearchPrice, initialSearchBedroom,
                                  priceFilter, bedroomFilter) {
  const API = `${APIPrefix.get()}/search_api/properties`;
  if (isFirst) {
    const PRICE = initialSearchPrice;
    const TYPE = '';
    const BEDROOM = initialSearchBedroom;
    try {
      const NUMB_PER_PAGE = document.querySelector('.num-per-page').value;
      let DEVELOPMENT_STATUS_VALUE = '';
      let response = await fetch(
        `${API}?noOfItemsPerPage=${NUMB_PER_PAGE}&dataSourcePageId=${
          developmentDiv.id
        }&status=${DEVELOPMENT_STATUS_VALUE}&selectedPrice=${encodeURIComponent(
          PRICE
        )}&selectedPropertyType=${TYPE}&selectedNoOfBedrooms=${BEDROOM}`
      );
      if (response.status == 200) {
        let data = await response.json();
        return data;
      } else {
        throw new Error(response.status);
      }
    } catch (error) {
      console.log(error);
    }
  } else {
    let priceSelected = priceFilter.options[priceFilter.selectedIndex].value;
    const TYPE = '';
    let bedroomSelected = bedroomFilter.options[bedroomFilter.selectedIndex].value;
    try {
      const NUMB_PER_PAGE = document.querySelector('.num-per-page').value;
      let DEVELOPMENT_STATUS_VALUE = '';
      let response = await fetch(
        `${API}?noOfItemsPerPage=${NUMB_PER_PAGE}&dataSourcePageId=${
          developmentDiv.id
        }&status=${DEVELOPMENT_STATUS_VALUE}&selectedPrice=${encodeURIComponent(
          priceSelected
        )}&selectedPropertyType=${TYPE}&selectedNoOfBedrooms=${bedroomSelected}`
      );
      if (response.status == 200) {
        let data = await response.json();
        return data;
      } else {
        throw new Error(response.status);
      }
    } catch (error) {
      console.log(error);
    }
  }
}

function buildDevelopmentPropertyTable(developmentDiv, propertyData) {

  const HEADINGS = propertyData.headings;
  const ITEMS = propertyData.items;
  const CONFIGURATION = propertyData.configuration;
  let wrap = developmentDiv.querySelector('.table-results-wrapper');
  const PROP_LIST_TAB = wrap.querySelector('.property-list-component');
  const TABLE_WRAPPER = wrap.querySelector('.property-list-component .table-wrapper');
  const TABLE = document.createElement('table');
  TABLE.setAttribute('class', 'pagination');
  TABLE_WRAPPER.appendChild(TABLE);
  PROP_LIST_TAB.appendChild(TABLE_WRAPPER);
  for (const field in propertyData) {
    const THEAD = document.createElement('thead');
    const TABLE_ROW = document.createElement('tr');
    THEAD.appendChild(TABLE_ROW);
    const TBODY = document.createElement('tbody');
    if (field == 'headings') {
      for (const child in HEADINGS) {
        const HEADER_CELL = document.createElement('th');
        TABLE_ROW.appendChild(HEADER_CELL);
        HEADER_CELL.innerText = HEADINGS[child];
        TABLE.appendChild(THEAD);
      }
      const HEADER_CELL = document.createElement('th');
      HEADER_CELL.classList.add('disabled-sorting');
      TABLE_ROW.appendChild(HEADER_CELL);
      TABLE.appendChild(THEAD);
    } else if (field == 'items') {
      for (const child in ITEMS) {
        const TABLE_ROW = document.createElement('tr');
        let item = ITEMS[child].fields;
        let btn = ITEMS[child].button;
        for (const row in item) {
          const TABLE_DATA = document.createElement('td');
          TABLE_ROW.appendChild(TABLE_DATA);
          if (row === 'propertynumber') {
            if (btn.url !== '') {
              TABLE_DATA.innerHTML = `<a class="link--default" href="${btn.url}" title="${btn.tooltip}">${item[row]}</a>`;
            } else {
              TABLE_DATA.innerText = item[row];
            }
          } else {
            TABLE_DATA.innerText = item[row];
          }
          TBODY.appendChild(TABLE_ROW);
          TABLE.appendChild(TBODY);
        }
        if (btn.url !== '') {
          let link = document.createElement('a');
          link.setAttribute('href', btn.url);
          link.innerHTML = btn.name;
          link.setAttribute('class', 'button button--primary');
          link.setAttribute('title', btn.name);
          let NEW_CELL = TABLE_ROW.insertCell(-1);
          NEW_CELL.appendChild(link);
        } else {
          let link = document.createElement('span');
          link.innerHTML = 'Reserved';
          let NEW_CELL = TABLE_ROW.insertCell(-1);
          NEW_CELL.appendChild(link);
        }
      }
    }
  }

  if (ITEMS !== undefined && ITEMS.length !== 0) {
    let dataTable = tableUtils.initPaginatedDataTable(developmentDiv, CONFIGURATION, true, true);

    let paginationWrapper = developmentDiv.querySelector('.dataTable-pagination');
    if (paginationWrapper && paginationWrapper.hasChildNodes()) {
      tableUtils.initPaginationControlStates(dataTable, paginationWrapper);
      tableUtils.displayFirstPageAfterSort(dataTable, developmentDiv);
    }
  }
}

function handleLocalAreaIntersect(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
        observer.unobserve(entry.target);

        // create the Local Area Component
        LocalAreaComponent.init(entry.target, true);
      }
  });
}

function resizeMapContainer () {
  const mapContainer = document.querySelector('.search-results--wrap');
  const mapElement = document.getElementById('map');

  if (window.matchMedia('(orientation: landscape)').matches) {
    mapElement.style.height = `${getMapContainerHeight()}px`;
    mapContainer.style.height = `${getMapContainerHeight()}px`;
  } else {
    mapElement.style.height = '40vh';
    mapContainer.style.height = '100%';
  }
}

function resizeMapNotShownContainer () {
  let mapNotShownContainer = document.querySelector('.search-results--wrap');
  let mapNotShownElement = document.querySelector('.map-not-shown');
  if (window.matchMedia('(orientation: landscape)').matches) {
    mapNotShownElement.style.height = `${getMapContainerHeight()}px`;
    mapNotShownContainer.style.height = `${getMapContainerHeight()}px`;
  } else {
    mapNotShownElement.style.height = '40vh';
    mapNotShownContainer.style.height = 'auto';
  }
}

function getMapContainerHeight() {
  let body = window.innerHeight;
  let header = document.querySelector('header').clientHeight;
  let filters = document.querySelector('.search-bar--filters').clientHeight + document.querySelector('.search-bar--wrap').clientHeight;
  // due to box-sizing, margins and padding on elements are not included in clientHeights,
  // so we have to manually add the top/bottom margin/padding present on the
  // search-results container div (30px), and the search-bar-wrap div (15px)
  // plus 4 pixels worth of borders applied to the containers
  // hence the 'magic' number of 49. A correct value ensures correct display when resizing.
  let filterPanel = document.querySelector('.search-bar--filters');
  let searchWrap = document.querySelector('.search-bar--wrap');
    let availableHeight;

  if (filterPanel.classList.contains('open')) {
      availableHeight = body - header - searchWrap.clientHeight - 49;
  } else {
    availableHeight = body - header - filters - 49;
  }

  return availableHeight;
}

function handleBingError(e) {
  document.querySelector('.MicrosoftMap').hidden = true;
  handleNoBing();
}

function handleNoBing() {
  const BING_DOWN_WRAPPER = document.querySelector('.bing-down-wrapper');
  const MAP_ITEM = document.querySelector('#map');
  const SEARCH_RESULTS_FILTERS = document.querySelector('.search-bar--filters .search-bar');
  if (BING_DOWN_WRAPPER ) {
    // Display the Bing Not Available message
    BING_DOWN_WRAPPER.style.display = 'block';
    BING_DOWN_WRAPPER.style.height = '100%';

    if (!SEARCH_RESULTS_FILTERS) {
      // If it's not a Search results page then check for local area component
      const localAreaComponent = document.querySelector('.local-area-component');
      if (localAreaComponent) {
        LocalAreaComponent.init(localAreaComponent, false);
      }

      setupSearchBarNoBing();

      // then we don't need to do anything else, so return
      return;
    } else {
      // set up event handlers to make sure container sizes correctly
      resizeMapNotShownContainer();
      windowUtils.addOrientationListener(resizeMapNotShownContainer);
    }
  }
  if (MAP_ITEM) {
    MAP_ITEM.classList.add('visible');

    let isFirst;
    let developmentsData;

    const SEARCH_PRICE = SEARCH_RESULTS_FILTERS.querySelector('.price-filter--initial').value;
    const SEARCH_BEDROOM = SEARCH_RESULTS_FILTERS.querySelector('.bedroom-filter--initial').value;
    const PRICE_FILTER = document.getElementById('search-filter--prices');
    const BEDROOM_FILTER = document.getElementById('search-filter--bedrooms');
    const DEV_LIST_SEARCH = document.querySelector('.development-list--search');
    const SEARCH_FILTER = SEARCH_RESULTS_FILTERS.querySelectorAll('.search-filter');
    const SEARCH_BAR_ACTIONS = document.querySelector('.search-bar--actions');
    let searchEl = SEARCH_RESULTS_FILTERS.querySelector('.location-filter--initial').value;
    const LOCATION_FILTER = SEARCH_RESULTS_FILTERS.querySelector('.autocomplete--field');

    LOCATION_FILTER.value = searchEl;
    PRICE_FILTER.value = SEARCH_PRICE;
    BEDROOM_FILTER.value = SEARCH_BEDROOM;

    async function getSearchDataNoBing(first) {
      const API = `${APIPrefix.get()}/search_api/developmentsresults/`;
      if (first === true) {
        isFirst = true;
        try {
          const PRICE = SEARCH_PRICE;
          const TYPE = '';
          const BEDROOM = SEARCH_BEDROOM;
          const LOCATION = searchEl;
          let response = await fetch(
            `${API}list?price=${encodeURIComponent(
              PRICE
            )}&propertyType=${TYPE}&bedrooms=${BEDROOM}&location=${LOCATION}`
          );
          if (response.status == 200) {
            let data = await response.json();
            developmentsData = data;
            return data;
          } else {
            throw new Error(response.status);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        isFirst = false;
        try {
          let priceSelected = PRICE_FILTER.options[PRICE_FILTER.selectedIndex].value;
          const TYPE = '';
          let bedroomSelected = BEDROOM_FILTER.options[BEDROOM_FILTER.selectedIndex].value;

          let response = await fetch(
            `${API}list?price=${encodeURIComponent(
              priceSelected
            )}&propertyType=${TYPE}&bedrooms=${bedroomSelected}`,
            {
              method: 'get',
              mode: 'no-cors',
              headers: {
                'Access-Control-Allow-Origin' : '*'
              }
            }
          );
          if (response.status == 200) {
            let data = await response.json();
            developmentsData = data;
            return data;
          } else {
            throw new Error(response.status);
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    function devContainerNoBingHTML(containerData, thelist) {
      const OUTSIDE_DELIMITER = document.querySelector('.outside-delimiter').value;
      const LI = document.createElement('li');
      const SEARCH_BAR_INFO = document.querySelector('.search-bar--info');
      LI.innerHTML = `<h3>${OUTSIDE_DELIMITER}</h3>`;
      LI.classList.add('delimiter');
      thelist.appendChild(LI);
      SEARCH_BAR_INFO.classList.add('show');
      if (containerData.data.items.length > 0) {
        for (const details in containerData.data.items) {
          const ID = containerData.data.items[details].developmentId;
          const LI = document.createElement('li');
          let devBlock = buildDevelopmentBlock(ID);
          LI.appendChild(devBlock.element);
          thelist.appendChild(LI);
          let observer = new IntersectionObserver(handleSearchNoBingIntersect, devBlock.options);
          observer.observe(devBlock.element);
        }
      } else {
        setSearchResultsPageLayout(containerData);
      }
    }
    function handleSearchNoBingIntersect(entries, observer) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          let data_ID = entry.target.dataset.id;
          const developmentDiv = entry.target; //the div that is visible in viewport

          async function getSearchInfoNoBing() {
            try {
              let DEVELOPMENT_STATUS_VALUE = '';
              let infoResponse = await fetch(
                `${APIPrefix.get()}/search_api/developments/details?developmentId=${data_ID}&status=${DEVELOPMENT_STATUS_VALUE}`
              );
              if (infoResponse.status == 200) {
                let info = await infoResponse.json();
                return info;
              } else {
                throw new Error(response.status);
              }
            } catch (error) {
              console.log(error);
            }
          }

        getSearchInfoNoBing().then((info) => {
          let itemsInfo = info.data;
          let devId = developmentDiv.getAttribute('data-id');
          const NP = document.querySelector('.num-of-props').value;
          const NO_OF_PROP = document.querySelector('.num-of-prop').value;
          let numberOfProperties;
          for (const item in developmentsData.data.items) {
            if (developmentsData.data.items[item].developmentId === devId) {
              numberOfProperties = developmentsData.data.items[item].developmentNoOfProperties;
            }
          }
          const NO_OF_PROPS = NP.replace('{0}', numberOfProperties);
          developmentDiv.innerHTML = getSearchListDevelopmentHTML(devId, itemsInfo, numberOfProperties, NO_OF_PROPS, NO_OF_PROP);
          let wrap = developmentDiv.querySelector('.table-results-wrapper');
          let btn = developmentDiv.querySelector('.prop-table');
          getSearchTableData(developmentDiv, isFirst, SEARCH_PRICE, SEARCH_BEDROOM,
            PRICE_FILTER, BEDROOM_FILTER).then((data) => {

              buildDevelopmentPropertyTable(developmentDiv, data.data);
          });
          tableUtils.initShowPropertiesButton(wrap, btn);
        });
      }
    }
  }

  getSearchDataNoBing(true).then((data) => {
    setSearchResultsPageLayout(data);
    updateSearchResultsInfo(document.querySelector('.empty-results').value, true);
    devContainerNoBingHTML(developmentsData, DEV_LIST_SEARCH);
  });

    SEARCH_FILTER.forEach(function (SEARCH_FILTER) {
      SEARCH_FILTER.addEventListener('change', function (e) {
        if (SEARCH_BAR_ACTIONS) {
          if (SEARCH_FILTER.id === 'search-filter--prices') {
            let updatablePrice = SEARCH_BAR_ACTIONS.querySelector('.price-filter--initial');
            updatablePrice.value = PRICE_FILTER[PRICE_FILTER.selectedIndex].value;
          }
          if (SEARCH_FILTER.id === 'search-filter--bedrooms') {
            let updatableBedroom = SEARCH_BAR_ACTIONS.querySelector('.bedroom-filter--initial');
            updatableBedroom.value = BEDROOM_FILTER[BEDROOM_FILTER.selectedIndex].value;
          }
        }
        DEV_LIST_SEARCH.innerHTML = '';
        getSearchDataNoBing(false).then((data) => {
          const DEVS_PROPS_MSG = document.querySelector('.devs-props').value;
          let devsProps = DEVS_PROPS_MSG.replace('{0}', 0).replace('{1}', 0);
          updateSearchResultsInfo(devsProps, true);
          devContainerNoBingHTML(data, DEV_LIST_SEARCH);
        });
      });
    });
  } else {
    setupSearchBarNoBing();
  }
}

function setupSearchBarNoBing() {
  // Set up enabling/disabling of search button
  const searchBarComponents = document.querySelectorAll('.search-bar');
  if (searchBarComponents) {
    searchBarComponents.forEach((component) => {
      const location = component.querySelector('.autocomplete--field');
      const searchButton = component.querySelector('.update--button');
      // add Safari-only autocorrect attribute if using Safari browser
      if (detectSafari) {
          location.setAttribute('autocorrect', 'off');
      }
      // add autocapitalize attribute
      if ('visualViewport' in window) {
          location.setAttribute('autocapitalize', 'off');
      }
      location.addEventListener('keyup', (e) => {
        if (e.target.value.length) {
          searchButton.setAttribute('aria-disabled', 'false');
          searchButton.setAttribute('type', 'submit');
        } else {
          searchButton.setAttribute('aria-disabled', 'true');
          searchButton.setAttribute('type', 'button');
        }
      });
    });
  }
}